<template>
  <v-dialog v-model="ModalToSIMASN" persistent max-width="40%">
    <v-card>
      <v-card-title class="headline"> Sinkron Data Ke IDASN? </v-card-title>
      <v-card-text>
        Data penghargaan yang anda pilih akan disalin ke data penghargaan di
        IDASN!
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" small depressed @click="ModalToSIMASN = false">
          Batal
        </v-btn>
        <v-btn
          color="primary"
          small
          depressed
          :loading="lbtn"
          :disabled="lbtn"
          @click="toSAPK()"
        >
          Ya
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Cookie from "@/helper/cookie.js";
import Auth from "@/helper/auth.js";
import Library from "@/helper/lib.js";

import modal_tosimasnState from "@/store/asn/rwpenghargaan/modal_to_simasn";
import refreshView from "@/store/asn/rwpenghargaan/viewRwpenghargaan";

export default {
  name: "rwpenghargaanModalToSIMASN",
  data: () => ({
    token: Cookie.get("token"),
    lbtn: false,
    get_nip: "",
  }),

  computed: {
    ModalToSIMASN: {
      get() {
        return modal_tosimasnState.state.ModalToSIMASN;
      },

      set(value) {
        modal_tosimasnState.commit("toggleModal", value);
      },
    },

    item: {
      get() {
        return modal_tosimasnState.state.rwpenghargaan;
      },
    },

    idata: {
      get() {
        return modal_tosimasnState.state.dataUtama;
      },
    },
  },

  watch: {
    ModalToSIMASN() {},
  },

  methods: {
    async toSAPK() {
      this.lbtn = true;

      let data = {
        penghargaan_sapkid: this.item.sapk.id,
        penghargaan_id: this.item.penghargaan.id,
        sk_nomor: this.item.suratKeputusan.nomor,
        sk_tgl: Library.FDate(this.item.suratKeputusan.tanggal),
        tahun: this.item.tahun,
      };

      const url =
        process.env.VUE_APP_ASN +
        "penghargaan/nip/" +
        this.$route.params.id +
        "/salin";

      this.http
        .post(url, data, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        })
        .then((response) => {
          this.lbtn = false;
          if (response.data.success) {
            refreshView.commit("refreshData", true);
            refreshView.commit("alert", response.data.message);
            refreshView.commit("berhasilAlert", true);
            refreshView.commit("gagalAlert", false);
            refreshView.commit("success", response.data.success);
          } else {
            refreshView.commit("refreshData", true);
            refreshView.commit("alert", response.data.message);
            refreshView.commit("gagalAlert", true);
            refreshView.commit("berhasilAlert", false);
            refreshView.commit("success", response.data.success);
          }
          this.closeModal();
        })
        .catch((error) => {
          if (error.response.status == 401) {
            Auth.logout(this.token);
          } else if (error.response) {
            refreshView.commit("refreshData", true);
            refreshView.commit("alert", error.response.data.message);
            refreshView.commit("gagalAlert", true);
            refreshView.commit("berhasilAlert", false);
            refreshView.commit("success", error.response.data.success);
            console.log(error.response.status);
            this.lbtn = false;
          } else {
            refreshView.commit("refreshData", true);
            refreshView.commit("alert", error.response.data.message);
            refreshView.commit("gagalAlert", true);
            refreshView.commit("berhasilAlert", false);
            refreshView.commit("success", error.response.data.success);
            console.log(error.response.status);
            console.log("Error", error.message);
            this.lbtn = false;
          }
        });
    },

    closeModal() {
      this.ModalToSIMASN = false;
    },
  },
};
</script>
